import { render, staticRenderFns } from "./ProductListPreview.vue?vue&type=template&id=d96f545c"
import script from "./ProductListPreview.vue?vue&type=script&lang=js"
export * from "./ProductListPreview.vue?vue&type=script&lang=js"
import style0 from "./ProductListPreview.vue?vue&type=style&index=0&id=d96f545c&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/linkdeli/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d96f545c')) {
      api.createRecord('d96f545c', component.options)
    } else {
      api.reload('d96f545c', component.options)
    }
    module.hot.accept("./ProductListPreview.vue?vue&type=template&id=d96f545c", function () {
      api.rerender('d96f545c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ProductListPreview.vue"
export default component.exports